const SPECIALS = "!@#$%^&*()_+-=[]{};:,.?/";

export function passwordRules(pwd = "") {
  return {
    length: pwd.length >= 12,
    uppercase: /[A-Z]/.test(pwd),
    lowercase: /[a-z]/.test(pwd),
    number: /[0-9]/.test(pwd),
    special: [...pwd].some((c) => SPECIALS.includes(c)),
  };
}

export function passwordValid(pwd) {
  return Object.values(passwordRules(pwd)).every(Boolean);
}

export function passwordStrength(pwd = "") {
  let score = Object.values(passwordRules(pwd)).filter(Boolean).length; // 0-5
  if (pwd.length >= 16 && score >= 4) score = Math.min(5, score);
  return score;
}

export function normalizeUrl(url = "") {
  const u = (url || "").trim();
  if (!u) return "";
  if (/^javascript:|^data:|^file:/i.test(u)) return "";
  if (!/^https?:\/\//i.test(u)) return `https://${u}`;
  return u;
}

export function isValidUrl(url = "") {
  const n = normalizeUrl(url);
  if (!n) return false;
  try {
    const u = new URL(n);
    if (!["http:", "https:"].includes(u.protocol)) return false;
    return u.hostname.includes(".") && u.hostname.length > 3 && !u.hostname.includes("@");
  } catch {
    return false;
  }
}

export function isLinkedInUrl(url = "") {
  const n = normalizeUrl(url);
  if (!n) return false;
  try {
    const u = new URL(n);
    return /(^|\.)linkedin\.com$/i.test(u.hostname);
  } catch {
    return false;
  }
}

export function isValidEmail(email = "") {
  const e = (email || "").trim();
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e);
}
